module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 20h-4c-1.106 0-2 .894-2 2v3a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3c0-1.106-.894-2-2-2H4V4h24v16zm-17.386-6H14v4.996c0 .552.452 1.004 1.004 1.004h2A1 1 0 0 0 18 18.996V14h3.394c.594 0 .788-.532.43-1.002L16.65 6.356c-.358-.474-.936-.48-1.292-.01l-5.174 6.652c-.358.472-.164 1.002.43 1.002z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-5.js
// module id = 1187
// module chunks = 14